// packages/frontend/src/lib/formatPhone.ts

/**
 * Display-only US phone formatter. Returns "(XXX)XXX-XXXX" for a 10-digit
 * number (or an 11-digit number with a leading country "1"). Anything that
 * isn't cleanly 10 digits — 7-digit, has an extension, letters, foreign — is
 * returned trimmed but otherwise untouched, so we never show a mangled number.
 * Blank / null → null, so callers fall back to their existing "No phone" state.
 *
 * NEVER use on a value that is stored or sent to an API — display text only.
 */
export function formatPhone(value: string | null | undefined): string | null {
  if (value == null) return null;
  const digits = value.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length === 10) return `(${ten.slice(0, 3)})${ten.slice(3, 6)}-${ten.slice(6)}`;
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}
